import { useNavigation } from '@react-navigation/native';
import React from 'react';
import { Image, ScrollView, StyleSheet, Text, TouchableOpacity, View } from 'react-native';

import { useAuth } from '../hooks/useAuth';

export default function ProfileScreen() {
  const navigation = useNavigation();
  const { user, logout } = useAuth();

  const menuItems = [
    { icon: '👤', label: '编辑资料', onPress: () => {} },
    { icon: '🔐', label: '账号安全', onPress: () => {} },
    { icon: '🔔', label: '消息通知', onPress: () => {} },
    { icon: '🌙', label: '深色模式', onPress: () => {} },
    { icon: '💬', label: '语言', onPress: () => {} },
    { icon: '📦', label: '存储空间', onPress: () => {} },
    { icon: '❓', label: '帮助与反馈', onPress: () => {} },
    { icon: 'ℹ️', label: '关于', onPress: () => navigation.navigate('About' as any) },
  ];

  return (
    <ScrollView style={styles.container}>
      {/* 用户信息 */}
      <View style={styles.userSection}>
        <TouchableOpacity style={styles.avatarContainer} onPress={() => {}}>
          <Image
            source={{ uri: user?.avatar || 'https://via.placeholder.com/100' }}
            style={styles.avatar}
          />
          <View style={styles.avatarEdit}>
            <Text style={styles.avatarEditIcon}>📷</Text>
          </View>
        </TouchableOpacity>
        <Text style={styles.nickname}>{user?.nickname || '用户'}</Text>
        <Text style={styles.phone}>{user?.phone || ''}</Text>
      </View>

      {/* 菜单项 */}
      <View style={styles.menuSection}>
        {menuItems.map((item, index) => (
          <TouchableOpacity key={index} style={styles.menuItem} onPress={item.onPress}>
            <View style={styles.menuIcon}>{item.icon}</View>
            <Text style={styles.menuLabel}>{item.label}</Text>
            <Text style={styles.menuArrow}>›</Text>
          </TouchableOpacity>
        ))}
      </View>

      {/* 退出登录 */}
      <TouchableOpacity style={styles.logoutButton} onPress={logout}>
        <Text style={styles.logoutText}>退出登录</Text>
      </TouchableOpacity>

      {/* 版本信息 */}
      <Text style={styles.version}>v1.0.0</Text>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  avatar: {
    borderRadius: 40,
    height: 80,
    width: 80,
  },
  avatarContainer: {
    marginBottom: 16,
    position: 'relative',
  },
  avatarEdit: {
    alignItems: 'center',
    backgroundColor: '#c9a227',
    borderRadius: 14,
    bottom: 0,
    height: 28,
    justifyContent: 'center',
    position: 'absolute',
    right: 0,
    width: 28,
  },
  avatarEditIcon: {
    fontSize: 16,
  },
  container: {
    backgroundColor: '#f5f5f5',
    flex: 1,
  },
  logoutButton: {
    alignItems: 'center',
    backgroundColor: '#fff',
    borderRadius: 8,
    margin: 16,
    paddingVertical: 14,
  },
  logoutText: {
    color: '#ff4d4f',
    fontSize: 16,
    fontWeight: 'bold',
  },
  menuArrow: {
    color: '#ccc',
    fontSize: 24,
  },
  menuIcon: {
    fontSize: 24,
    marginRight: 16,
  },
  menuItem: {
    alignItems: 'center',
    borderBottomColor: '#f5f5f5',
    borderBottomWidth: 1,
    flexDirection: 'row',
    paddingHorizontal: 16,
    paddingVertical: 16,
  },
  menuLabel: {
    color: '#333',
    flex: 1,
    fontSize: 16,
  },
  menuSection: {
    backgroundColor: '#fff',
    marginTop: 16,
  },
  nickname: {
    color: '#333',
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 4,
  },
  phone: {
    color: '#999',
    fontSize: 14,
  },
  userSection: {
    alignItems: 'center',
    backgroundColor: '#fff',
    paddingVertical: 32,
  },
  version: {
    color: '#ccc',
    fontSize: 12,
    marginBottom: 24,
    textAlign: 'center',
  },
});
